module.exports = require("/tmp/build_d42a1fa0/src/lib/gatsby/gatsby-browser.tsx");